import { render, staticRenderFns } from "./PersonExamRecord.vue?vue&type=template&id=de71828e"
import script from "./PersonExamRecord.vue?vue&type=script&lang=js"
export * from "./PersonExamRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports